import React from 'react';
import PropTypes from 'prop-types';

import { ActionBtn, toast } from '@meronex/components';

import Dialog from '@material-ui/core/Dialog';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';

import ILocation from '@meronex/icons/en/EnLocation';
import TopHeader from '../../../../views/components/TopHeader';
import LocationForm from './LocationForm';

import { storesMng } from '../../../api/storesMng';

function LocationDialog(props) {

  const { open, onClose, onUpdate, storeItemId, item } = props;

  const [location, setLocation] = React.useState(
    item ? item.location || {} : null
  );

  const [updating, setUpdating] = React.useState();

  const updateLocation = async () => {
    try {
      setUpdating(true);
      await storesMng.storeItem.actions.modifyStoreItemLocation({
        storeItemId: item._id,
        location,
      });
      toast.success('Item location updated');
      if (onUpdate) {
        onUpdate();
      }
      onClose();
    } catch (e) {
      toast.error('Ops, something went wrong');
      console.error(e);
    } finally {
      setUpdating(false);
    }
  };

  if (!location) {
    return null;
  }

  return (
    <Dialog className={'fullScreenMobile'} open={open} onClose={onClose} scroll={'body'}>
      <DialogTitle>
        <TopHeader
          title={'Set Location'}
          onClose={onClose}
          icon={<ILocation size={20} />}
        />
      </DialogTitle>
      <DialogContent>
        <div>
          <LocationForm
            location={location}
            onChange={(v) => {
              setLocation(v);
            }}
          />
        </div>
        <div
          style={{
            width: '100%',
            marginTop: '10px',
            marginBottom: '10px',
            textAlign: 'center',
          }}>
          <ActionBtn
            loading={updating}
            onClick={() => {
              updateLocation();
            }}
          />
        </div>
      </DialogContent>
    </Dialog>
  );
}

LocationDialog.propTypes = {
  open: PropTypes.bool,
  onClose: PropTypes.func,
  onUpdate: PropTypes.func,
  location: PropTypes.object,
};

export default LocationDialog;
